import type { PagesConfig } from '#types/config/pages'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    heading: 'text-xl mb-6',
    trackOrderButton: ''
  },
  overrideTitles: true,
  showLoginForm: true,
  showOrderNumberToolTipImage: true,
  showZipCodeInput: true
} satisfies RecursivePartial<PagesConfig['orderStatus']>
